<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input
        v-model="params.name"
        placeholder="请输入名称"
        clearable
        size="small"
        class="param-input"
        style="width: 220px"
      ></el-input>
      <el-select
        placeholder="请选择类型"
        clearable
        size="small"
        v-model="params.type"
      >
        <el-option
          :label="item.label"
          :value="item.number"
          v-for="item in types"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-select
        placeholder="请选择是否开启"
        clearable
        size="small"
        v-model="params.status"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="item in statuses"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getList('status')"
        style="margin-right: 20px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="addAndEdit('add')"
        style="margin-right: 20px"
        >新增</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      height="600"
    >
      <el-table-column prop="id" label="ID" align="center" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.id || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="名称" align="center" width="240">
        <template slot-scope="scope">
          <span>{{ scope.row.name || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="类型" align="center" width="100">
        <template slot-scope="scope">
          <el-tag
            style="background-color: #ecf5ff;color: #409eff;border: 1px solid #d9ecff;"
            v-if="scope.row.type == 1"
            >动漫</el-tag
          >
          <el-tag type="success" v-else-if="scope.row.type == 2">漫画</el-tag>
          <el-tag type="danger" v-else-if="scope.row.type == 3"
            >文本小说</el-tag
          >
          <el-tag type="warning" v-else-if="scope.row.type == 4"
            >有声小说</el-tag
          >
          <el-tag type="info" v-else-if="scope.row.type == 5">剧场</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="是否开启"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status == 1">是</el-tag>
          <el-tag v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="sortCode" label="排序" align="center" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.sortCode || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAct"
        label="操作人"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.updatedAct || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.updateTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.createdAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="280"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            icon="el-icon-edit"
            @click="addAndEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            @click="del(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!-- 新增、修改 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="560px"
      @before-close="handleClose"
      @close="handleClose"
    >
      <el-form :model="form" label-width="100px" :rules="rules" ref="form">
        <el-form-item
          label="名称:"
          size="small"
          prop="name"
          style="width: 480px"
        >
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item
          size="small"
          label="排序:"
          prop="sortCode"
          style="width: 480px"
        >
          <el-input v-model.number="form.sortCode"></el-input>
        </el-form-item>
        <el-form-item
          size="small"
          label="类型:"
          prop="type"
          style="width: 480px"
        >
          <el-select v-model="form.type" placeholder="请选择类型">
            <el-option
              :label="item.label"
              :value="item.number"
              v-for="item in types"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          size="small"
          label="是否开启:"
          prop="status"
          style="width: 480px"
        >
          <el-select v-model="form.status" placeholder="请选择是否开启">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in statuses"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="onSubmit()"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
import { uniteDate } from "@/utils/validator.js";
import { animeTypes } from "../../../config/anime";

export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 10,
        status: undefined, // 状态
        name: undefined, // 名称
        type: undefined, // 状态
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      statuses: [
        {
          label: "开启",
          value: 1,
        },
        {
          label: "关闭",
          value: 2,
        },
      ],
      types: animeTypes,
      dialogTitle: "",
      dialogVisible: false,
      form: {
        id: undefined,
        name: undefined, // 名称
        sortCode: 0, // 排序
        status: 1, // 是否开启
        type: 1, // 类型
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.getLatitudeList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 新增播单
    addAndEdit(param) {
      if (param === "add") {
        this.dialogTitle = "新增";
      } else {
        this.dialogTitle = "编辑";
        // 把数据回显给表单
        this.form.id = param.id;
        this.form.name = param.name;
        this.form.type = param.type;
        this.form.sortCode = param.sortCode;
        this.form.status = param.status;
      }
      this.dialogVisible = true; // 打开新增、编辑对话框
    },
    // 新增、修改提交
    onSubmit() {
      if (this.dialogTitle === "新增") {
        this.add();
      } else {
        this.edit();
      }
    },
    // 新增方法
    add() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          API.addLatitude(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "新增成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "新增失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 修改方法
    edit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          API.updateLatitude(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "编辑失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    del(param) {
      this.$confirm(
        `确认是否删除<span style='color:blue'>${param.name}</span>, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          let delData = {
            id: param.id,
          };
          API.delLatitude(delData).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: "删除失败!",
              });
            }
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭窗口清除数据
    handleClose() {
      this.form.id = undefined;
      this.form.name = undefined;
      this.form.sortCode = 0;
      this.form.type = 1;
      this.form.status = 1;
      this.dialogVisible = false;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getList();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getList();
    },
    // 更换时间格式
    changeTime(time) {
      return uniteDate(time);
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
/deep/ .el-form-item__content {
  display: flex;
}
/deep/ .el-select {
  width: 100%;
}
/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 120px;
  height: 120px;
}
/deep/ .el-upload--picture-card {
  width: 120px;
  height: 120px;
  line-height: 130px;
}
</style>
